module.exports = __webpack_public_path__ + "img/news_bg.032e6396.png";